import React, { useState, useEffect } from "react";
import {
	DateTimeInput,
	Edit,
	FormTab,
	useRefresh,
	TabbedForm,
	TextInput,
	useUpdate,
	useNotify,
	useRedirect,
	useTranslate,
} from "react-admin";

import { validateBusinessData } from "./businessValidate";
import { CustomToolbar } from "../../customComponents/CustomToolbar";
import { CustomTransferList } from "../../customComponents/CustomTransferList";
import { setIndexesForData } from "../../utils/customFunctions";

export const BusinessEdit = (props) => {
	const redirect = useRedirect();
	const refresh = useRefresh();
	const translate = useTranslate();
	const notify = useNotify();
	const [update] = useUpdate("businesses", props.id);

	const onSuccess = () => {
		notify("businesses.edit.success", "info");
		redirect("/businesses");
		refresh();
	};

	const onFailure = (error) => {
		notify(error.message, "warning");
	};

	return (
		<Edit {...props} title={translate("businesses.edit.title")}>
			<TabbedForm
				toolbar={<CustomToolbar />}
				save={({ validFrom, validTo, ...data }) => {
					validFrom = new Date(validFrom).toLocaleString();
					validTo = new Date(validTo).toLocaleString();
					const indexedDataToSend = setIndexesForData(data, [
						"modules",
					]);
					update(
						{
							payload: {
								data: {
									...indexedDataToSend,
									validFrom,
									validTo,
								},
							},
						},
						{
							onSuccess,
							onFailure,
						}
					);
				}}
				validate={validateBusinessData}
				syncWithLocation={false}
			>
				<FormTab label={translate("businesses.tabs.basicInfo.label")}>
					<TextInput source="name" />
					<DateTimeInput source="validFrom" />
					<DateTimeInput source="validTo" />
				</FormTab>
				<FormTab
					label={translate("businesses.tabs.modulesManagement.label")}
				>
					<CustomTransferList
						source="modules"
						referenceSource="modules"
						referenceResource="modules"
						referenceField="name"
						isReferenceTranslatable={false}
					/>
				</FormTab>
			</TabbedForm>
		</Edit>
	);
};
